<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">

        <!-- <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="true"
          :show-add-button="accessLevel"
          caption="<i class='fa fa-align-justify'></i> Customer Listing"
          addButton="Tambah Customer"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table> -->


        <global-table
          :table-data="getData"
          :total-data="totalRows"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="orderForm"
          :redirect-detail="true"
          :show-add-button="true"
          :upload-by-excell="true"
          caption="<i class='fa fa-align-justify'></i> Order Listing"
          addButton="Tambah Order"
          addExcellButton="Upload Order"
          @editForm="editForm"
          @isEdit="isEdit"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Form Order</h3>
          </div>

          <b-form id="orderForm" validated novalidate>
            <template v-if="!formLoading">
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="customer" label="Customer">
                        <vue-autosuggest
                          v-model="customers.text"
                          @inputout="focusMe"
                          :suggestions="filteredOptions"
                          @input="onInputChange"
                          @selected="onSelected"
                          :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control'}"
                          :limit="20"
                        >
                          <template slot-scope="{ suggestion }">
                            <span class="my-suggestion-item"> 
                              {{ suggestion.item.text }}
                            </span>
                          </template>
                        </vue-autosuggest>
                    </b-form-group>
                    <template>
                      <div v-if="orderForm.customer_id === null">
                        <strong style="color: red">*Customer harus di pilih</strong>
                      </div>
                    </template>
                  <!-- <b-form-group label-for="customer_id" label="Konsumen">
                    <model-select
                      id="customer_id"
                      :options="listCustomer"
                      v-model="$v.orderForm.customer_id.$model"
                      :isError="$v.orderForm.customer_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="orderForm.customer_id === null"
                      class="invalid-feedback-custom"
                    >Konsumen harus di isi.</div>
                  </b-form-group> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="plan_delivery_order" label="Tanggal Pengiriman">
                    <v-date-picker
                      id="plan_delivery_order"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengiriman', required: ''}"
                      :state="!$v.orderForm.plan_delivery_order.$invalid"
                      v-model="$v.orderForm.plan_delivery_order.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.orderForm.plan_delivery_order.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal pengiriman harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label-for="order_type" label="Jenis Order">
                    <model-select
                      id="order_type"
                      :options="listOrderType"
                      v-model="$v.orderForm.order_type.$model"
                      :isError="$v.orderForm.order_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="orderForm.order_type === null"
                      class="invalid-feedback-custom"
                    >Jenis order harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.orderForm.description.$model"
                      :state="!$v.orderForm.description.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-row v-else>
              <b-col>
                <loading></loading>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!formLoading">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="submitAdd"
                :disabled="$v.orderForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>

        <b-modal
          ref="uploadExcell"
          id="addModalsByExcell"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Form Upload Order</h3>
          </div>

          <b-form id="uploadOrderForm" validated novalidate>
            <b-row v-if="!formLoading">
              <b-col sm="4">
                <b-form-group label-for="file" label="Upload Excel">
                  <b-form-file
                    ref="inputDocument"
                    accept=".xls, .xlsx, .csv"
                    @change="OnUploadSelect($event)"
                    v-model="uploadOrderForm.file"
                    required
                  ></b-form-file>
                  <div
                    v-if="uploadOrderForm.file === null || uploadOrderForm.file === undefined"
                    class="invalid-feedback-custom"
                  >Upload order anda dalam format excel.</div>
                </b-form-group>
              </b-col>
              <b-col sm="2">&nbsp;</b-col>
              <b-col sm="6">
                <strong>
                  <small>Contoh format excel untuk indomaret, ketika akan upload. Pastikan formatnya sama</small>
                </strong>
                <b-table
                  v-bind:key="'a'"
                  :fields="fieldsExample"
                  :items="itemsExample"
                  :striped="true"
                  :bordered="true"
                ></b-table>
                <p class="text-center">Atau</p>
                <strong>
                  <small>Contoh format excel untuk Gerai Tradisional (GT), ketika akan upload. Pastikan formatnya sama</small>
                </strong>
                <b-table
                  v-bind:key="'b'"
                  :fields="fieldsExampleGT"
                  :items="itemsExampleGT"
                  :striped="true"
                  :bordered="true"
                ></b-table>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <loading></loading>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!formLoading">
              <b-button type="button" size="sm" variant="danger" @click="cancelUpload">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="processUploadOrder"
                :disabled="$v.uploadOrderForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import loading from "@/templates/Loading.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  name: "order",
  components: {
    globalTable,
    ModelSelect,
    loading,
    VueAutosuggest
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orders: [],
      customers: {
        text: null,
        value: null
      },
      filteredOptions: [],
      suggestions: [
        {
          data: [],
        },
      ],
      fields: [
        { key: "order_number", sortable: true },
        { key: "customer_name", label: "Nama Konsumen" },
        { key: "qty_total_order", label: "Jumlah Pesanan" },
        { key: "total_price_plan", label: "Jumlah Order" },
        { key: "employee_name", label: "Di input oleh" },
        { key: "plan_delivery_order", label: "Tanggal Pengiriman" },
        { key: "action", class: "text-center width-80" }
      ],
      fieldsExample: [
        { key: "customer_code", label: "Kode Konsumen" },
        { key: "product_name", label: "Nama Produk" },
        { key: "qty", label: "Qty" },
        { key: "delivery_date", label: "Tanggal Kirim" }
      ],
      itemsExample: [
        { customer_code: "FHV2", product_name: "AICE ICE OBOR 65G", qty: "2", delivery_date: "2019.08.30" },
        { customer_code: "Kolom A", product_name: "Kolom B", qty: "Kolom C", delivery_date: "Kolom D" }
      ],
      fieldsExampleGT: [
        { key: "customer_code", label: "Nama Konsumen" },
        { key: "product_name", label: "Nama Produk" },
        { key: "qty", label: "Qty" },
        { key: "delivery_date", label: "Tanggal Kirim" }
      ],
      itemsExampleGT: [
        { customer_code: "TOKO JUAN", product_name: "AICE Bingo", qty: "1", delivery_date: "2019.08.30" },
        { customer_code: "Kolom A", product_name: "Kolom B", qty: "Kolom C", delivery_date: "Kolom D" }
      ],
      orderForm: interfaces.order,
      uploadOrderForm: { file: null },
      loading: true,
      formLoading: false,
      listCustomer: [],
      listPricingUnit: [],
      listEmployee: [],
      listOrderType: [],
      uploadListExcell: ["xls", "xlsx", "csv"],
      totalRows: "",
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    orderForm: {
      customer_id: { required },
      plan_delivery_order: { required },
      description: {},
      order_type: {required}
    },
    uploadOrderForm: {
      file: { required }
    }
  },
  methods: {
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/order/all', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    init: function() {
      //this.loading = true;
      //this.getAllOrder();
      this.getDropdown();
    },
    // getAllOrder: function() {
    //   this.axios
    //     .get("web/order/all/")
    //     .then(response => {
    //       this.orders = response.data.data;
    //     })
    //     .catch(error => {})
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    onSelect: function(event) {
      //console.log(event);
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-order/")
        .then(response => {
          this.listCustomer = response.data.customer;
          this.listPricingUnit = response.data.pricing_unit;
          this.listOrderType = response.data.order_type;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(a) {
      this.resetForm();
      this.orderForm = a;
    },
    resetForm: function() {
      this.formLoading = false;
      for (var a in interfaces.order) {
        interfaces.order[a] = null;
      }
      this.orderForm = interfaces.order;
    },
    resetFormUploadForm: function() {
      this.formLoading = false;
      this.$refs["inputDocument"].reset();
      this.uploadOrderForm.file = null;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    cancelUpload: function() {
      this.resetFormUploadForm();
      this.$refs.uploadExcell.hide();
    },
    OnUploadSelect: function(event) {
      const file = event.target.files[0];
      const fileArray = file.name.split(".");
      const totalArray = fileArray.length - 1;
      if (this.uploadListExcell.includes(fileArray[totalArray])) {
        this.uploadOrderForm.file = event.target.files[0];
      } else {
        this.resetFormUploadForm();
      }
    },
    processUploadOrder: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan order ?")) {
        this.formLoading = true;
        let uploadOrder = new FormData();
        uploadOrder.append("employee_id", localStorage.getItem("employee_id"));
        uploadOrder.append("file", this.uploadOrderForm.file);
        this.axios
          .post("web/order/upload-file/", uploadOrder)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Add Order",
                message: response.data.message
              });
              this.init();
            }
          })
          .catch(error => {
            this.expired(error, "Upload Order");
            this.resetFormUploadForm();
          })
          .finally(() => {
             this.$refs.uploadExcell.hide();
            this.resetFormUploadForm();
          });
      }
      //console.log(this.uploadOrderForm);
    },
    submitAdd: function(evt) {
      evt.preventDefault();

      if (confirm("Apakah anda ingin menambahkan order ?")) {
        let order = this.orderForm;
         this.formLoading = true;
       order.employee_id = localStorage.getItem("employee_id");
        this.axios
          .post("web/order/add/", order)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Add Order",
                message: response.data.message
              });
            }
            this.cancelAdd();
            this.$router.push({ path: "all/detail/" + response.data.id });
          })
          .catch(error => {
            this.expired(error, "Tambah Order");
            this.resetForm();
          })
          .finally(() => {});
      }
    },
    isEdit: function(flag) {
      return flag;
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.orderForm.customer_id = null
        this.customers.text = null;
        this.customers.value = null;
        return;
      } else {
        this.orderForm.customer_id = item.item.value;
        this.customers.text = item.item.text;
        this.customers.value = item.item.value;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.orderForm.customer_id = null
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>